import { useContext } from 'react';

import { SignedInUserContext } from '../providers/SignedInUserProvider';

export const useLocale = () => {
    const { locale } = useContext(SignedInUserContext);
    return locale;
};
